var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.video_url && _vm.embed_url)?_c('iframe',{attrs:{"width":"450","height":"253","src":_vm.embed_url,"webkitallowfullscreen":"","mozallowfullscreen":"","allowfullscreen":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }